module.exports = __webpack_public_path__ + "static/media/homeText.84764572.md";